<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-btn text dark v-on="on">
        <v-icon small left>fa-arrow-circle-down</v-icon>
        Importer les configurations à partir d'une autre succursale
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Importation de la configuration de base
      </v-card-title>
      <v-card-text>
        <v-row align="center" no-gutters>
          <v-select
            v-model="store"
            label="Choisir une succursale pour importer les configurations"
            item-text="name_store"
            item-value="id_store"
            :items="getAvailablesStores.filter(x => x.id_store !== getStoreId)"
          ></v-select>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" no-gutters justify="space-between">
          <v-btn
            text
            :block="$vuetify.breakpoint.xsOnly"
            :class="{ 'mb-1': $vuetify.breakpoint.xsOnly }"
            @click="dialog = false"
          >
            Annuler
          </v-btn>
          <v-btn
            color="primary"
            @click="importData"
            :block="$vuetify.breakpoint.xsOnly"
            :disabled="!store"
          >
            <v-icon small left>fa-arrow-circle-down</v-icon>
            Importer les configurations
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "RecipeImportDialog",
  computed: {
    ...mapGetters(["getStoreId", "getAvailablesStores"])
  },
  data() {
    return {
      dialog: false,
      store: null
    };
  },
  methods: {
    async importData() {
      if (this.store) {
        try {
          this.$store.dispatch("slo");
          await api.importRecipeStoreData({ store: this.store });
          this.dialog = false;
          await this.$store.dispatch("loadAllRecipeStore");
        } finally {
          this.$store.dispatch("elo");
        }
      }
    }
  }
};
</script>

<style></style>
